import { useState } from 'react';
import toast from 'react-hot-toast';
import { format } from 'date-fns';

import TituloSessao from '../componentes/TituloSessao';
import TelaInformativa from './TelaInformativa';
import DataMesControlled from '../componentes/DataMesControlled';
import { CONSTANTES } from '../config/constantes'

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { servReciboEnvioIndicadoresMes, servDownloadFilePorFilename } from '../servicos/servicosEmRotasPrivadas/download';
import { servPostIndicadorLote } from '../servicos/servicosEmRotasPrivadas/indicador';
import { toastErrorPydantic } from '../util/toast_pydantic';

function InformarIndicadoresPlanilha() {

    console.log('### Iniciando InformarIndicadoresPanilha ###');

    const [arquivo, setArquivo] = useState(null);
    const [mesReferencia, setMesReferencia] = useState(null);
    const [exibirTelaInformativa, setExibeTelaInformativa] = useState(false)
    const [erros, setErros] = useState(false)
    const [show, setShow] = useState(false);

    console.log(mesReferencia);

    async function postIndicadorLote() {

        if (!arquivo) {
            toast.error('Selecione um arquivo');
            return;
        }
        
        if (!mesReferencia) {
            toast.error('Selecione o mês de referência');
            return;
        }

        const formData = new FormData();

        formData.append('arquivo', arquivo);
        formData.append('mesReferencia', mesReferencia.toISOString());

        try {
            const response = await toast.promise(
                servPostIndicadorLote(formData),
                { loading: 'Processando planilha enviada...' }
            )
            await servReciboEnvioIndicadoresMes(mesReferencia) // Entregando o recibo
            setExibeTelaInformativa(true)

        } catch (error) {
            setArquivo(null)
            if (error?.response?.data?.codigoErro === 6002) {
                setShow(true)
                setErros(error.response.data.erros)
            } else {
                toastErrorPydantic(error)
            }
        }

    }

    const handleClose = () => setShow(false);

    const handleFileChange = (e) => {
        setArquivo(e.target.files[0]); // só pega o primeiro arquivo (caso não seja múltiplo)
        e.target.value = null // tive que fazer isso pq ao tentar subir o arquivo de novo,
        // por ter o mesmo nome, era tido como mesmo arquivo, mesmo tendo seu conteudo atualizado
    };

    if (exibirTelaInformativa) {
        return <TelaInformativa cabecalho='Indicadores cadastrados com sucesso!'
            mensagem='Clique no botão abaixo para retornar à tela de cadastro de indicadores'
            pathRedirect={null}
            buttonMessage='Voltar'
            urlExterna={false} />;
    }

    return (
        <div className='container d-flex flex-column gap-3'>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Erro ao Informar Indicadores</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {erros && erros.map((erro, index) => (
                        <table className="table">
                            <thead>
                                <tr key={index}>
                                    <th scope="col">Linha: {erro.linha}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {erro.erros.map((erroLinha) => (
                                    <tr>
                                        <td>{erroLinha}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ))}

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        FECHAR
                    </Button>
                </Modal.Footer>
            </Modal>

            <TituloSessao titulo='Informar Indicadores por Planilha' barraDecorativa={false} centralizaTitulo={true} />
            <div className='div-com-borda d-flex flex-column flex-md-row gap-3 p-3'>
                <div className='d-flex flex-column gap-3 col-12 col-md-6'>
                    <div>
                        {arquivo ? (
                            <div>
                                <p>Arquivo selecionado: <strong>{arquivo.name}</strong></p>
                                <button type="button"
                                    className="btn btn-secondary w-25"
                                    onClick={() => { setArquivo(null) }}>
                                    LIMPAR
                                </button>
                            </div>
                        ) : (
                            <div>
                                <label
                                    className='form-label'
                                    htmlFor='planilha-indicadores' >
                                    Planilha <strong>padrão</strong> preenchida com os indicadores
                                </label>
                                <input
                                    id='planilha-indicadores'
                                    className='form-control form-control'
                                    type='file'
                                    accept='.xlsx'
                                    onChange={handleFileChange}
                                />
                            </div>
                        )}
                    </div>

                    <div>
                        <p className="m-0">
                            # <a
                                onClick={() => servDownloadFilePorFilename(CONSTANTES.DOWNLOAD_PLANILHA_ENVIO_INDICADORES)}
                                className="pe-auto"
                                role="button"
                            >
                                Clique aqui
                            </a> para baixar a planilha padrão #
                        </p>
                    </div>

                </div>

                <div className='col-12 col-md-3'>
                    <label
                        className='form-label'
                        htmlFor='mes-competencia'>
                        Mês Referência
                    </label>
                    <DataMesControlled
                        id='mes-competencia'
                        value={mesReferencia}
                        onChange={setMesReferencia}
                        getUltimoDia={false}
                    />
                </div>

            </div>
            <button
                className='btn btn-primary'
                onClick={postIndicadorLote}
            >
                ENVIAR
            </button>
        </div>
    );
}

export default InformarIndicadoresPlanilha
